import { createEntityReducer } from 'next/lib/collections';

const TYPE = 'features';

export default createEntityReducer(TYPE);

export const selectFeatures = state => state[TYPE];
export const selectFeature = (state, feature) => selectFeatures(state)[feature];
